import { Editor, Node, Path, Point, Range, Transforms } from 'slate'
import { string } from 'prop-types'
import { useSlateStatic } from 'slate-react'
import cc from 'classcat'
import hotkeys from 'slate-hotkeys'

import { getList } from '../lists'

export function isQuote(editor) {
  const [node] = Editor.nodes(editor, { match: (node) => node.type === 'blockquote' })

  return Boolean(node)
}

export function quoteEventHandler(editor, event) {
  if (hotkeys.isSplitBlock(event)) {
    // When hitting Enter - while on a new empty line of a quote - exit that quote.
    if (isQuote(editor) && Range.isCollapsed(editor.selection)) {
      const [[node, path]] = Editor.nodes(editor, { match: (node) => node.type === 'blockquote' })
      const lastChildIndex = node.children.length - 1
      const lastChildIsEmpty = Node.string(node.children[lastChildIndex]) === ''
      const lastChildPoint = { path: [...path, lastChildIndex, 0], offset: 0 }

      // Checking if we are on an empty line which is the end of the quote.
      if (lastChildIsEmpty && Point.equals(editor.selection.focus, lastChildPoint)) {
        Transforms.moveNodes(editor, { at: [...path, lastChildIndex], to: Path.next(path) })
        event.preventDefault()
      }
    }
  }
}

export default function QuoteButton({ title }) {
  const editor = useSlateStatic()

  const { isList } = getList(editor)
  const isActive = isQuote(editor)

  function handleMouseDown(event) {
    event.preventDefault()

    if (isActive) Transforms.unwrapNodes(editor, { match: (n) => n.type === 'blockquote' })
    else Transforms.wrapNodes(editor, { type: 'blockquote' })
  }

  return (
    <button
      className={cc([
        'dali-plugin-text-toolbar-button',
        'dali-plugin-text-toolbar-button-blockquote',
        { active: isActive },
      ])}
      data-command-name="blockquote"
      type="button"
      title={title}
      disabled={isList}
      onMouseDown={handleMouseDown}
    />
  )
}

QuoteButton.propTypes = { title: string.isRequired }
